export default __webpack_public_path__ + "static/media/ic_xcircle.66c97022.svg";